
import {store} from '../../utils/';

export default {
	//登录成功后的用户信息
	user: store.get('user') ||null,
  token: store.get('token') || null,
	refreshToken: store.get('refreshToken') || null,
	menus: store.get('menus') || null,
	identity: store.get('identity') || null,	//用户身分 1:医院,2:卫计委,3:运营
	selectedMenu: null,							//当前选中菜单
	menuRight: {},								//选中菜单权限
  loginType: store.get('loginType') || null,	//登录类型
  tenantId: store.get('tenantId') || null,	//租户
  tenantName: store.get('tenantName') || null,	//租户名
  tenants: store.get('tenants') || null,	//租户列表
};